import Locations from "../components/Locations/Locations";
import Location from "../components/Locations/Location";
import {PERM} from "../utilites/permissions";

const locations = [
  {
    path: '/locations',
    name: 'Locations',
    component: Locations,
    meta: {requiresAuth: true,
      permissions: [
        PERM.LOCATION,
        PERM.LOCATION_READ,
      ]
    },
    props: true,
  },
  {
    path: '/locations/new',
    name: 'LocationAdd',
    component: Location,
    meta: {requiresAuth: true,
      permissions: [
        PERM.LOCATION,
        PERM.LOCATION_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/locations/view/:location_id',
    name: 'LocationView',
    component: Location,
    meta: {requiresAuth: true,
      permissions: [
        PERM.LOCATION,
        PERM.LOCATION_READ,
      ]
    },
    props: true
  },
  {
    path: '/locations/edit/:location_id',
    name: 'LocationEdit',
    component: Location,
    meta: {requiresAuth: true,
      permissions: [
        PERM.LOCATION,
        PERM.LOCATION_EDIT,
      ]
    },
    props: true
  },
];

export default locations;



// WEBPACK FOOTER //
// ./src/router/locations.js